import { inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LoginResponse } from "@core/models/api.response";
import { userCredentialsDTO } from "@core/models/dto.models";
import { LoginService } from "@core/services/login.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ErrorDialogComponent } from "@shared/components/error-dialog/error-dialog.component";
import { metacomActions } from "@shared/store/metacom/actions";
import { of, switchMap } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { loginActions } from "./actions";

export const authLoginEffect = createEffect(
  (actions$ = inject(Actions), authService = inject(LoginService)) => {
    return actions$.pipe(
      ofType(loginActions.requestLogin),
      switchMap((data: userCredentialsDTO) => {
        return authService.login(data).pipe(
          map((data: LoginResponse) => {
            if (data.access_token) {
              return loginActions.requestLoginSuccess(data);
            } else {
              return loginActions.requestLoginFailed(data);
            }
          }),
          catchError((error) => {
            return of(
              loginActions.requestLoginFailed({
                message: error.message as string,
              })
            );
          })
        );
      })
    );
  },
  { functional: true }
);

export const authLoginSuccessEffect = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(loginActions.requestLoginSuccess),

      map((data: LoginResponse) => metacomActions.requestMetacomConnection())
    );
  },
  { functional: true }
);

export const authLoginFailedEffect = createEffect(
  (actions$ = inject(Actions), dialog = inject(MatDialog)) => {
    return actions$.pipe(
      ofType(loginActions.requestLoginFailed),
      map((data) => {
        dialog.open(ErrorDialogComponent, {
          data: {
            errorMessage:
              data.message ??
              "Login attempt was unsuccessful. Please try again.",
          },
        });
      })
    );
  },
  { dispatch: false, functional: true }
);
